if (!customElements.get('product-form')) {
  
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
     (async () => {
      evt.preventDefault();
   var productId= this.form.querySelector('[name="product-id"]').value;
   var cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(response => {  return response });
    var sampleExist= true;
    var sampleCount=0;
     var sampleInput = document.querySelector('input[name="properties[_sample]"]');
    cartContents.items.forEach(function(item){

       if (item.properties && item.properties._sample)
       {
           sampleCount++;
       }
    if (item.properties && item.properties._sample == productId && !sampleInput.disabled) { 
      sampleExist = false; 
    }
    })
   if(sampleCount >=20 && !sampleInput.disabled) {
    alert(window.cartStrings.sample_count_error);
    document.querySelector('[name="add"]').setAttribute('disabled','true')
    return false; 
   }
       
   if(!sampleExist) {
    alert(window.cartStrings.sample_error);
    document.querySelector('[name="add"]').setAttribute('disabled','true')
    return false; 
   }   
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      let quantity_yard = formData.get('quantity') * 1;
      formData.set('quantity', quantity_yard);

      // Check with data have snip variant
      for (const item of formData.entries()) {
        if (item[1].indexOf('snip') > -1 || item[1].indexOf('Snip') > -1 ) {
          formData.set('quantity', 1);
        }
      }

      if (this.cart) {
        
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          response.quantityAddCart = quantity_yard
          console.log("response",response);



          
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.classList.add('added');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (this.submitButton) {
            setTimeout(function(that){ that.submitButton.classList.remove('added'); }, 1000, this);
          }
        });

  
})();
}

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  
  });
}
